module.exports = __webpack_public_path__ + "static/media/spades_3.5e4bad97.png";